import * as React from "react";
import {
  List, Datagrid, FunctionField, Show, SimpleShowLayout,
  useRecordContext,
} from "react-admin";
import { Box, Typography } from "@mui/material";
import { PersonChip } from "../../components/ui";
import { ConfirmActionButton } from "../../components/ConfirmActionButton";
import { EnumChip } from "../../components/EnumChip";
import { InfoGrid } from "../../components/InfoGrid";
import { SUGGESTION_STATUS } from "../../enums";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";
import { FrDateField } from "../../components/FrDateField";
import { TechInfo } from "../../components/ui";

// Backend : GET /admin/suggestions/specialities (suggestions PENDING
// uniquement, sans filtre), GET /{id}, PUT /{id}/approve, PUT /{id}/reject.
// Ni édition ni suppression : pas de vue edit, pas d'actions groupées.

const Approve = () => {
  const r = useRecordContext();
  if (!r || r.status === "VALIDATED") return null;
  return (
    <ConfirmActionButton
      label="Approuver" color="success" size="small"
      confirmTitle="Approuver" confirmText={`Approuver "${r.name}" ?`}
      successMessage="Suggestion approuvée"
      onConfirm={() => httpClient(`${API_BASE_URL}/admin/suggestions/specialities/${r.id}/approve`, { method: "PUT", body: JSON.stringify({}) })}
    />
  );
};
const Reject = () => {
  const r = useRecordContext();
  if (!r || r.status === "REJECTED") return null;
  return (
    <ConfirmActionButton
      label="Rejeter" color="error"
      confirmTitle="Rejeter" confirmText={`Rejeter "${r.name}" ?`}
      successMessage="Suggestion rejetée"
      onConfirm={() => httpClient(`${API_BASE_URL}/admin/suggestions/specialities/${r.id}/reject`, { method: "PUT", body: JSON.stringify({}) })}
    />
  );
};

export default {
  list: () => (
    <List perPage={25}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <FunctionField label="Spécialité proposée" sortBy="name" render={(r) => (
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{r?.name}</Typography>
            {r?.job && <Typography variant="caption" color="text.secondary">Métier : {r.job}</Typography>}
          </Box>
        )} />
        <FunctionField label="Proposé par" render={(r) => (
          <PersonChip
            id={r?.suggestedBy}
            name={r?.suggestedByName}
            email={r?.suggestedByEmail}
            resource="professionals"
          />
        )} />
        <EnumChip source="status" enumObj={SUGGESTION_STATUS} />
        <FrDateField source="createdAt" label="Proposé le" showTime />
        <FunctionField label="Actions" render={() => (
          <Box sx={{ display: "flex", gap: 1 }} onClick={(e) => e.stopPropagation()}>
            <Approve />
            <Reject />
          </Box>
        )} />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <InfoGrid
          fields={[
            { label: "ID", source: "id", type: "mono" },
            { label: "Nom de la spécialité", source: "name" },
            { label: "Domaine médical", source: "domainMedical" },
            { label: "Métier rattaché", source: "job" },
            { label: "Couleur", source: "color", type: "mono" },
            { label: "Mots-clés", source: (r) => Array.isArray(r?.keywords) ? r.keywords.map(k => k?.name || k) : [], type: "list" },
            { label: "Présentiel uniquement", source: "presentielOnly", type: "bool" },
            { label: "Durée moy. (min)", source: "averageDurationMinutes" },
            { label: "Statut", source: "status" },
            { label: "Proposée par (nom)", source: (r) => r?.suggestedByName || "—" },
            { label: "Proposée par (email)", source: "suggestedByEmail" },
            { label: "Proposée par (ID)", source: "suggestedBy", type: "mono" },
            { label: "Proposée le", source: "createdAt", type: "datetime" },
          ]}
        />
        <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
          <Approve /><Reject />
        </Box>
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
